module.exports = __webpack_public_path__ + "doctor_5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_5.jpg
// module id = 892
// module chunks = 0